/* eslint-disable */ 
import React, { useState } from "react";
import { useFormik } from "formik";

import { Link } from "react-router-dom";
import { InvoiceLogo1 } from "../_components/Imagepath";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { emailrgx } from "../assets/constant";
import axios from "../api/axios";
import {  Apitoken } from "../Global";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
const schema = yup.object({
  email: yup
    .string()
    .matches(emailrgx, "Email is required")
    .required("Email is required")
    .trim(),
  password: yup.string().min(6).max(6).required("Password is required").trim(),
});

const CustomerLogin = (props) => {
  const [eye, seteye] = useState(true);
  const [backendErrors, setBackendErrors] = useState([]);
  const [backendSuccess, setBackendSuccess] = useState(false);
 
  const {
    values,
    errors,

    handleBlur,
    handleChange,
    handleSubmit,
  } = useFormik({
    initialValues: {
      password: "",
      email: "",
    },
    onSubmit: (values, actions) => {
     
      axios
        .post("/customerportal/login", values, { headers: { Apitoken: Apitoken } })
        .then((response) => {
          actions.setSubmitting(false);
          console.log(response.data);
          setBackendSuccess('')
          delete backendErrors['error'];
          if (response.data.code === 200) {
         
            console.log(response.data.data);
          
            let profile_image = response.data.data.user.profile_image;
            let responsetoken = response.data.data.user.auth_token;
            let auth_fname = response.data.data.user.user_first_name;
            let auth_lname = response.data.data.user.user_last_name;
            let auth_email = response.data.data.user.user_email;
            let user_id = response.data.data.user.id;
            let customer_id = response.data.data.user.customer_id;
             let menu_modules =    JSON.stringify(response.data.data.modules); 

                 
            let season_id = response.data.data.season.id;
            let season_start = response.data.data.season.start;
            let season_name = response.data.data.season.name;
            let season_end = response.data.data.season.end;

             setBackendSuccess(response.data.message);
              toast.success(response.data.message);
              localStorage.setItem("customer_info", JSON.stringify(response.data.data.customer));
              localStorage.setItem("profile_image", profile_image);
              localStorage.setItem("season_id", season_id);
              localStorage.setItem("season_start", season_start);
              localStorage.setItem("season_end", season_end);
              localStorage.setItem("season_name", season_name);
              localStorage.setItem("customer_id", customer_id);
              localStorage.setItem("isLoggedIn", true);
              localStorage.setItem("auth_token", responsetoken);
              localStorage.setItem("user_type", 'customer');
              localStorage.setItem("role_type", response.data.data.user.user_type);
              localStorage.setItem("auth_id", user_id);
              localStorage.setItem("role_id", 1);
              localStorage.setItem("fname", auth_fname);
              localStorage.setItem("lname", auth_lname);
              localStorage.setItem("auth_email", auth_email);
              localStorage.setItem("menu_modules", menu_modules);

             localStorage.setItem("all_seasons", JSON.stringify(response.data.data.seasons));
            setTimeout(() => {
              // if(role_id === 3){
              //   window.location.href = "/customer/index";
              // }else{
              window.location.href = "/customerportal/profile";
              // }
            }, 1000);
          } 
          else if (response.data.code === 422) {
              setBackendErrors(response.data.error);
          }
          else if (response.data.code === 401) {
            setBackendErrors(response.data.error);
          }
          else {
             setBackendErrors(response.data.error);
          }
        })
        .catch((error) => {
          actions.setSubmitting(false);
        });
    },
  });
  const onEyeClick = () => {
    seteye(!eye);
  };
  const customHandleInput = (event) => {
    const Input_name = event.target.name;
    delete backendErrors[Input_name];
  };

  const isLoggedInVAr =  localStorage.getItem("auth_id");
 
  return (
    <><ToastContainer />
      <div className="main-wrapper login-body">
        <div className="login-wrapper">
          <div className="container">
            <img
              className="img-fluid logo-dark mb-2"
              src={InvoiceLogo1}
              alt="Logo"
            />
            <div className="loginbox">
              <div className="login-right">
                <div className="login-right-wrap">
                  <h1>Login</h1>
                  <p className="account-subtitle">Access to our dashboard</p>
                  <div>
                    <form  onSubmit={handleSubmit}>
                      <div className="input-block mb-3 input_text">
                        <label className="form-control-label">
                          Email Address
                        </label>
                      
                         <input
                          type="email"
                          name="email"
                          className={
                            errors.email
                              ? "form-input form-control input-error"
                              : "form-input form-control"
                          }
                          placeholder="Email"
                          value={values.email}
                          onChange={(e) => {
                            handleChange(e);
                            customHandleInput(e);
                          }}
                          onBlur={handleBlur}
                        />
                         

                         <small>
                            {backendErrors.email && (
                            <span className="form-error mt-1">
                              {backendErrors.email}
                            </span>
                          )}
                          </small>
                      </div>
                      <div className="input-block mb-3 input_text login-eye">
                        <label className="form-control-label">Password</label>
                        <input
                            type={eye ? "password" : "text"}
                            name="password"
                            className={
                              errors.password
                                ? "form-input form-control input-error"
                                : "form-input form-control"
                            }
                            placeholder="Password"
                            value={values.password}
                            onChange={(e) => {
                              handleChange(e);
                              customHandleInput(e);
                            }}
                            onBlur={handleBlur}
                          />
                      

                        <small className="error-validation">
                           {backendErrors.password && (
                            <span className="form-error mt-1">
                              {backendErrors.password}
                            </span>
                          )}

                        {backendErrors.error  && (
                          <span className="form-error mt-1">
                            {backendErrors.error}
                          </span>  )}
                            {backendSuccess && (
                          <span className="from-success mt-1">
                            {backendSuccess}
                          </span> )} 

                        </small>
                      </div>
                      <div className="input-block mb-3">
                        <div className="row">
                          <div className="col-6">
                            <div className="custom-control custom-checkbox">
                              <input
                                type="checkbox"
                                className="form-check-input"
                                id="cb1"
                              />
                              <label
                                className="custom-control-label ms-1"
                                htmlFor="cb1"
                              >
                                Remember me
                              </label>
                            </div>
                          </div>
                          
                          <div className="col-6 text-end">
                            <Link className="forgot-link" to="/customerportal/forgot-password">
                              {" "}
                              Forgot Password ?{" "}
                            </Link>
                          </div>
                        </div>
                      </div>
                      <button
                        className="btn btn-lg btn-block w-100 btn-primary w-100"
                        type="submit"
                      >
                        Login
                      </button>
                    </form>
                   
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default CustomerLogin;
